import { CustomAutocomplete, CustomTextArea, CustomTextFieldNumberComponente, GeneralTable } from "@/shared/components/ui";
import { useFetchMotivosRechazo } from "@/shared/actions/erp";
import { useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Grid } from "@mui/material";
import {
  EstadoProspectoEnum, gridSizeMdLg12, ModulosEnumChoice, newEditarProspecteoSchema,
  ROUTER_PATHS,
  TABLE_CONSTANTS, texto
} from "@/shared";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useState } from "react";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FormEditProspecto, ISolicitudCanje, MotivoRechazo } from "@/shared/interfaces";
import { usePutProspectoCorporativo } from "@/shared/actions/erp/prospecto_corporativo.actions";
import { IMotivoRechazoCorporativo } from "@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface";
import { newMotivoProspecteoCorporativoSchema } from "@/shared/utils/validation-schemas/erp/ventas/prospecto/prospecto_corporativo.schema";
// import { useFetchSolicitudEvento } from "@/shared/actions/erp/marketing/solicitudEvento.action";
import { useFetchSolicitudCanje } from "@/shared/actions/erp/marketing";
import { useTableColumnsMarketing } from "@/shared/hooks/useTableColumnsMarketing";
import { PermissionsEnum } from "@/auth/interfaces";
import { useNavigate } from "react-router-dom";

interface TableSolicitudCanjeProps {
  showCustomActionBtnSpace?: boolean
  enableEditing?: boolean
  estado_prospecto?: EstadoProspectoEnum
}


export default function TableSolicitudCanje({
}: TableSolicitudCanjeProps) {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_solicitudcanje,
    PermissionsEnum.api_change_solicitudcanje
  ]);


  ///* use state
  const [modal, setModal] = useState(false);
  const [modalCancelar, setModalCancelar] = useState(false);

  const navigate = useNavigate()

  ///* form
  const form = useForm<FormEditProspecto>({
    resolver: yupResolver(newEditarProspecteoSchema),
  });

  const {
    reset,
    control,
    formState: { errors },
  } = form;

  const formRechazo = useForm<IMotivoRechazoCorporativo>({
    resolver: yupResolver(newMotivoProspecteoCorporativoSchema)
  });

  const {
    reset: resetMotivoRechazar,
  } = formRechazo;

  ///* Hooks
  const {
    ColumnsSolicitudCanje
  } = useTableColumnsMarketing();

  const {
    pagination,
    // searchTerm,
    // dateBefore,
    // dateAfter,

    setPagination,
    vendedor,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const {
    data: motivosRechazoPaging,
    isLoading: isLoadingMotivosRechazo,
    isRefetching: isRefetchingMotivosRechazo,
  } = useFetchMotivosRechazo({
    estado: true,
    modulo: ModulosEnumChoice.PROSPECTO_CORPORATIVO,
    page_size: 100,

  });

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { isLoading, data: dataSolicitudCanje, isRefetching } =
    useFetchSolicitudCanje({
      page: pageIndex + 1,
      user_create: vendedor,
      ...filterObject,
      filterByState: false,
      pageSize
    });

  const { mutateAsync: mutateAsyncProspectoCorp } = usePutProspectoCorporativo({
    enableAlert: true
  });

  const onEdit = (original: ISolicitudCanje) => {
    console.log(original)
    navigate(`${ROUTER_PATHS.marketing.solicitudesCanjeEditarNav}/${original?.id_solicitud_canje}`);
  };




  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>

        <Grid item xs={12}>
          <GeneralTable<ISolicitudCanje>
            columns={ColumnsSolicitudCanje}
            data={dataSolicitudCanje?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            ///* search
            enableGlobalFilter={false}
            enableSorting={false}
            // onGlobalFilterChange={setGlobalFilter}
            ///* pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataSolicitudCanje?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            // crud
            canEdit={true}
            enableEditing={true}
            showCustomActionBtnSpace={false}
            onEdit={val=>onEdit(val)}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}

          />
        </Grid>
      </Grid>


      {/*Modal para cancelar*/}

      {modalCancelar && (
        <ScrollableDialogProps
          open={modalCancelar}
          title="¡Confirmar!"
          confirmVariantBtn="contained"
          dialogContentText={`Estás a punto de cancelar un prospecto del cliente ${formRechazo.getValues().razon_social}
          con la identificación ${formRechazo.getValues().identificacion}. ¿Estás seguro? Este cambio es irreversible.`}
          contentNode={
            <Grid container spacing={3}>

              <CustomAutocomplete<MotivoRechazo>
                label="Motivo de rechazo"
                name="motivo_rechazo"
                // options
                options={motivosRechazoPaging?.data?.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={formRechazo.getValues().motivo_rechazo || ''}
                isLoadingData={isLoadingMotivosRechazo || isRefetchingMotivosRechazo}
                // validation
                control={formRechazo.control}
                error={formRechazo?.formState?.errors.motivo_rechazo}
                helperText={formRechazo?.formState?.errors.motivo_rechazo?.message}
                disableClearable
              />

              <CustomTextArea
                label="Observación"
                name="observacion_cancelacion"
                maxRows={3}
                control={formRechazo.control}
                defaultValue={formRechazo.getValues().observacion_cancelacion ?? ''}
                error={formRechazo.formState.errors.observacion_cancelacion}
                helperText={formRechazo.formState.errors.observacion_cancelacion?.message}
                required={false}
              />
            </Grid>
          }
          onConfirm={formRechazo.handleSubmit(async () => {
            const resp = await mutateAsyncProspectoCorp({
              id: formRechazo.getValues().id_prospecto_corporativo!,
              data: {
                estado_prospecto: EstadoProspectoEnum.CANCELADO,
                motivo_rechazo: formRechazo.getValues().motivo_rechazo,
                observaciones: {
                  observacion_cancelar: formRechazo.getValues().observacion_cancelacion
                }
              }
            });
            if (resp.code === 200) {
              resetMotivoRechazar({ id_prospecto_corporativo: '', motivo_rechazo: '' });
              setModalCancelar(false);
            }
          })}
          onClose={() => {
            resetMotivoRechazar({ id_prospecto_corporativo: '', motivo_rechazo: '' });
            setModalCancelar(false)
          }}
        />
      )}


      {/*Modal para editar numero de celular*/}

      {modal && (
        <ScrollableDialogProps
          open={modal}
          title="Editar Información de Prospecto"
          confirmTextBtn="Cambiar"
          contentNode={
            <Grid container spacing={3}>
              <CustomTextFieldNumberComponente
                size={gridSizeMdLg12}
                type={TiposTextFieldNumberEnum.CELULAR}
                label={texto.celular}
                error={errors.celular}
                helperText={errors.celular?.message}
                control={control}
                name="celular"
                defaultValue={form.getValues().celular || ''}
              />
            </Grid>
          }
          onConfirm={form.handleSubmit(async () => {
            await mutateAsyncProspectoCorp({
              id: form.getValues().id_prospecto,
              data: {
                celular: form.getValues().celular
              }
            });
            reset({ celular: '', id_prospecto: '' });
            setModal(false);
          })}
          onClose={() => setModal(false)}
        />
      )
      }


    </>

  );



}